module.exports = __webpack_public_path__ + "img/1519380635.13e26fb1.jpg";